module.exports = __webpack_public_path__ + "img/files-done.e7a38d89.jpg";